// @flow
import type { ZuzuAction } from 'types';

import { createReducer } from 'actions';
import { LOAD_SURVEYS } from 'actions/surveys';
import { LOGOUT } from 'actions/auth';
import type { Survey, LoadSurveysAction } from 'actions/surveys';

type State = {
  all: Array<Survey>,
};

const initialState: State = {
  all: [],
  error: null,
};

export default createReducer(
  initialState,
  {
    [LOAD_SURVEYS]: (state: State, action: LoadSurveysAction) => {
      if (action.meta.done && !action.meta.error && action.payload) {
        return {
          ...state,
          all: [...action.payload],
          error: null,
        };
      }
      return state;
    },

    [LOGOUT]: () => {
      return { ...initialState };
    },
  },
  (state: State, action: ZuzuAction) => {
    return {
      ...state,
      error: action.payload,
    };
  }
);



// WEBPACK FOOTER //
// ./src/redux/reducers/surveys.js